export default __webpack_public_path__ + "static/media/navigation-rail-labels.15f1f161.png";